// extracted by mini-css-extract-plugin
module.exports = {"container":"_945336dc","text":"_4d6c9ca6","tooltipText":"_72c575d3"};